import { CSSProperties, ReactFragment } from 'react'
import { useAuth } from '../../../auth/AuthContext'
import { Role } from '../../../data/types/medico.types'
import { version } from '../../../data/version'

const logo = require('./kaiteki-logo-azul.jpg')

const DivSpaceBetween = ({ children }: { children: ReactFragment}) => {
	const spacedDiv: CSSProperties = {
		margin: '6px 12px',
		display: 'flex',
		justifyContent: 'space-between',
 
	}
 
	return (
		<div style={spacedDiv}>
			{children}
		</div>
	)
}
 
const Header =() => {
 
	const logoStyle: CSSProperties = {
		height: '30px',
		width: 'auto',
		marginRight: '8px',
		verticalAlign: 'middle'
	}

	const titleContainerStyle: CSSProperties = {
		display: 'flex',
		alignItems: 'center'
	}

	const { role, nombreCompleto } = useAuth()

	return (
		<DivSpaceBetween>
			<div style={titleContainerStyle}>
				<a href={process.env.REACT_APP_APP_URL || '#'}> 
					<img src={logo} alt="Kaiteki Logo" style={logoStyle} /> 
				</a>
				<span title={`Version ${version}`}>{`Kaiteki Salud - Portal ${role === Role.ADMIN ? 'Administrador' : 'Médico'}`}</span>
			</div>
			<div style={{ alignSelf: 'center'}}>{`Hola, ${nombreCompleto}!`}</div>
		</DivSpaceBetween>
	)
}
 
export default Header
